module.exports = __webpack_public_path__ + "img/mb-visual-background.ee747d3e.jpg";